module.exports = __webpack_public_path__ + "static/foto-bg-baulen-d7f0563a0e506a9932c0be0bf7e184c5.jpg";